import axios from "axios";
const APIUrl = 'https://saleshangry.com/shapi/v1/';


/**
 * Function is use for get the IP address of your system.
 */
export function getIpAddress() {
	return axios.get('https://api.ipify.org/?format=json');
}

/**
 * Function is use for sign up the user.
 */
export async function signUp(userData) {
	let currentData = new Date();
	let newDate = new Date(Date.UTC(currentData.getUTCFullYear(), currentData.getUTCMonth(), currentData.getUTCDate(), currentData.getUTCHours(), currentData.getUTCMinutes(), currentData.getUTCSeconds()));
	let token = (newDate / 1000) * 440;
	var headers = {
		'Token': token
	}
	return axios.post(APIUrl + 'signup', userData, { headers: headers })
		.then(response => {
			return response.data.response;
		})
}

/**
 * Function is use for sign up the user.
 */
export async function signUpWithCard(userData) {
	let currentData = new Date();
	let newDate = new Date(Date.UTC(currentData.getUTCFullYear(), currentData.getUTCMonth(), currentData.getUTCDate(), currentData.getUTCHours(), currentData.getUTCMinutes(), currentData.getUTCSeconds()));
	let token = (newDate / 1000) * 440;
	var headers = {
		'Token': token
	}
	return axios.post(APIUrl + 'signup-with-card', userData, { headers: headers })
		.then(response => {
			return response.data.response;
		})
}

/**
 * Function is use for check the email is exist or not.
 * @param {*} email 
 */
export function checkEmailExist(email) {
   let params = {
      email: email
   }
   return axios.get(APIUrl + 'verify-email', {params})
      .then(response => {
         return response.data.response;
      }).catch(error => {
         console.log(error);
      })
}